export default "__VITE_ASSET__BSAItheS__"